import React from 'react';
import { cn } from '../lib/utils';
type ButtonProps<T extends React.ElementType> = {
  as?: T;
  variant: 'primary' | 'ghost';
  className?: string;
} & (T extends 'button'
  ? React.ButtonHTMLAttributes<HTMLButtonElement>
  : T extends 'a'
  ? React.AnchorHTMLAttributes<HTMLAnchorElement>
  : { [key: string]: unknown });

export default function Button<T extends React.ElementType = 'button'>({
  as,
  variant,
  className,
  ...props
}: ButtonProps<T>) {
  const Component: React.ElementType = as || 'button';

  const mergedClassNames = cn(
    {
      'bg-[#1937E0]': variant === 'primary',
      'border border-[#393939] bg-[#18181B]': variant === 'ghost'
    },
    'text-sm font-medium px-4 py-2 block rounded-[70px] cursor-pointer',
    className
  );

  // Return the component with its props
  return <Component {...props} className={mergedClassNames} />;
}
